import apiClient from './apiClient';

export class PermissionSchemeGroupService {
  static async index() {
    const response = await apiClient.get('api/v1/permission_scheme_groups');
    return response.data;
  }
}
